const PIECE_VALUES: Record<string, number> = {
  p: 100,
  n: 320,
  b: 330,
  r: 500,
  q: 900,
  k: 20000,
};

export function pieceValue(piece: string): number {
  return PIECE_VALUES[piece.toLowerCase()] ?? 0;
}

export function materialBalance(fen: string): number {
  const board = fen.split(" ")[0] ?? "";
  let balance = 0;
  for (const char of board) {
    if (!/[pnbrqkPNBRQK]/.test(char)) continue;
    const value = PIECE_VALUES[char.toLowerCase()] ?? 0;
    balance += char === char.toUpperCase() ? value : -value;
  }
  return balance;
}

export function materialDelta(fenBefore: string, fenAfter: string): number {
  return materialBalance(fenAfter) - materialBalance(fenBefore);
}

export function isSacrifice(fenBefore: string, fenAfter: string, mover: "white" | "black"): boolean {
  const delta = materialDelta(fenBefore, fenAfter);
  const moverDelta = mover === "white" ? delta : -delta;
  return moverDelta < 0;
}
